var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooManyRequests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-error-429",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}svg#freepik_stories-error-429:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1105",
    className: "animable",
    style: {
      transformOrigin: "250.013px 343.222px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.86 248c-91.09-52.59-238.29-52.59-328.79 0s-90 137.85 1.07 190.44 238.29 52.6 328.79 0S505 300.58 413.86 248Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250.013px 343.222px"
    },
    id: "el7ed8fqhcnue",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1105",
    className: "animable",
    style: {
      transformOrigin: "255.889px 351.3px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "265.595px 445.105px"
    },
    id: "el20sbq1g0st7",
    className: "animable",
    d: "m229.29 445.35 19.15 18.26 53.46-18.75-19.15-18.26-53.46 18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "128.865px 374.325px"
    },
    id: "elrw22gfuljzm",
    className: "animable",
    d: "m133.62 380.82 7.8 4.5 25.95-15.08-44.4-25.64-25.96 15.09 11.39 6.57-18.04 2.64 15.53 35.15 35.68-5.22-7.95-18.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.82 347.58 50.76-21.12L397 309.12 356.54 326l-.8-9.33 1.47.34L371 297.2l-51.29-12 37.16-21.46-26-15.09-44.4 25.64 23.43 13.61-10.76 15.47 19.93 4.63-25.87.69 11.45-22.81-35.36-6 15.58 20.83-15.58-20.83-11.21 22.32-60.73 1.62 1.52 17.81-15.87-3.75-13.84 19.75 44.06 10.43-49 2.6 3.47 21.24 57.73-3 .59 1.46-33 3.43 3.9 12.36-31.31 10.27 2.13 2.17-8.73-2.99-31.17 31.4 32 10.67 23.3-23.5 13.51 13.76 29.75-9.76-2.48 2.5 32 10.67 21.82-22 3 1.73 41-23.69 30.64-10.82L330.62 356l.52.2 20.56-17.66-24-9.42 22.66-.61-4.06 1.69ZM165.64 418l-5.11-17.08 5.11 17.08Zm121.56-97.32 5.33-10.61 1.14 13.4-4.84 4.16-12.41-8.78Zm-25.52 2.78-.61-7.23 11.86 2-33.72 16 1.82-2.6-28.86-6.83Zm-5 71.35-.07-.26.07.26Zm5.47-3.16-7.15-2.38-14.9 15-6.24-19.76 52.85-7.08Zm-42.9 16.22 19.34-2-10.71 10.8Zm42.47 3.76-4.2-14Zm30.23-37.18-7.52-18.59-55.27 7.39-1.94-11.89 4.78-6.82L249.5 357l37.8-17.9 24 9.42-23.17 8.18 20.06 19-9.18-5.33Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "273.205px 343.16px"
    },
    id: "elhds29d17plp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "321.65px 421.755px"
    },
    id: "elshjby6xmy",
    className: "animable",
    d: "m297.48 437.41 36.12 4.23 12.22-35.53-36.12-4.24-12.22 35.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.15 364.08c18-10.39 47.06-10.39 64.93 0s17.77 27.22-.21 37.6-47.06 10.39-64.93 0-17.77-27.22.21-37.6Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "375.51px 382.878px"
    },
    id: "el0ydt03r4odu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.39 275 158 336.88a8.24 8.24 0 0 1-8.26 0l-54.3-31.36a2.06 2.06 0 0 1 0-3.57l106.39-61.85a8.24 8.24 0 0 1 8.26 0l54.3 31.36a2.06 2.06 0 0 1 0 3.54Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "179.902px 288.49px"
    },
    id: "els88l9o7yecn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1105",
    className: "animable",
    style: {
      transformOrigin: "171.29px 180.635px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "207.56px 292.925px"
    },
    id: "el2kn66wqudjr",
    className: "animable",
    d: "m153.92 312.8-.07 22.64 107.35-62.39.07-22.64-107.35 62.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.44 280.79 98 259.19l-.12 43.94 55.94 32.31.07-22.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "125.885px 297.315px"
    },
    id: "eli8tw6fxjlw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.44 280.79 98 259.19l-.12 43.94 55.94 32.31.07-22.64Z",
    style: {
      opacity: 0.3,
      transformOrigin: "125.885px 297.315px"
    },
    className: "animable",
    id: "elbzq8mis1w9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.92 312.8 107.35-62.39-18.47-32-107.36 62.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.355px 265.605px"
    },
    id: "elc6klrx1tl9n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.92 312.8 107.35-62.39-18.47-32-107.36 62.38Z",
    style: {
      opacity: 0.1,
      transformOrigin: "198.355px 265.605px"
    },
    className: "animable",
    id: "el6o7v63221s9"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "236.076px 245.294px"
    },
    className: "animable",
    id: "elgv370cx1dbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.35 233.2 6.29 13.24a.83.83 0 0 1-.23 1.08l-17.72 10.23a.69.69 0 0 1-.94-.4l-6.26-13.19c0-.1-.06-.17-.08-.23a1.53 1.53 0 0 1 0-.27 1.7 1.7 0 0 1 .05-.23 1.06 1.06 0 0 1 .11-.19.61.61 0 0 1 .17-.16l17.73-10.23a.49.49 0 0 1 .17-.06.4.4 0 0 1 .22 0 .42.42 0 0 1 .18.07.69.69 0 0 1 .2.15 1.3 1.3 0 0 1 .11.19Zm4.78 13.18L242 235.49l-3.81 12.33a.67.67 0 0 1-.29.38.53.53 0 0 1-.43.05l-12.1-3.25 5.2 11 16.56-9.56m-6.6-11.12-14.39 8.31 10.91 3 3.48-11.27",
    style: {
      fill: "#fff",
      transformOrigin: "236.076px 245.294px"
    },
    id: "else7vipp3hq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "170.41px 238.8px"
    },
    id: "el8jtgg5q5nlv",
    className: "animable",
    d: "m242.79 218.41-37.41-21.6-107.35 62.38 37.41 21.6 107.35-62.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "170.41px 238.8px"
    },
    className: "animable",
    d: "m242.79 218.41-37.41-21.6-107.35 62.38 37.41 21.6 107.35-62.38z",
    id: "el9tl6zlotfho"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "163.15px 234.61px"
    },
    className: "animable",
    d: "M205.38 196.81 98.03 259.19l22.89 13.22 107.35-62.39-22.89-13.21z",
    id: "el936kaomqaa"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "168.05px 283.215px"
    },
    id: "elfaqg3uqjbxc",
    className: "animable",
    d: "m179.92 262.09-36.04 20.95 12.29 21.3 36.05-20.95-12.3-21.3z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "172.509px 283.214px"
    },
    className: "animable",
    id: "elja1amdb6cn8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "169.58px 280.88px"
    },
    id: "ellx9llbd3rh",
    className: "animable",
    d: "m171.82 283.34-1.48.85-3-5.33 2.22-1.29 2.26 5.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42 284.46a1.19 1.19 0 0 1 1.72.64 1.49 1.49 0 0 1-.49 2 1.23 1.23 0 0 1-1.75-.66 1.46 1.46 0 0 1 .52-1.98Z",
    style: {
      fill: "#fff",
      transformOrigin: "172.023px 285.776px"
    },
    id: "elpnidg74ii3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 281.75a3.68 3.68 0 0 1 1.35 2.83 2.81 2.81 0 0 1-1.27 2.54l-9.32 5.38a2.28 2.28 0 0 1-2.62-.3 3.68 3.68 0 0 1-1.34-2.83l-.19-12.9a2.78 2.78 0 0 1 1.27-2.54 2.27 2.27 0 0 1 2.61.29Zm.3 2.71a2.21 2.21 0 0 0-.81-1.7l-9.5-7.52a1.38 1.38 0 0 0-1.57-.18 1.67 1.67 0 0 0-.77 1.53l.19 12.9a2.24 2.24 0 0 0 .81 1.7 1.38 1.38 0 0 0 1.57.18l9.32-5.38a1.7 1.7 0 0 0 .76-1.53",
    style: {
      fill: "#fff",
      transformOrigin: "172.509px 283.214px"
    },
    id: "elxo22ng25kw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "187.465px 271.93px"
    },
    id: "elfeob0x2ial",
    className: "animable",
    d: "m195.01 281.76-12.29-21.29-2.8 1.62 12.3 21.3 2.79-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "187.465px 271.93px"
    },
    className: "animable",
    d: "m195.01 281.76-12.29-21.29-2.8 1.62 12.3 21.3 2.79-1.63z",
    id: "elsdwi03w6ein"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "168.05px 292.855px"
    },
    className: "animable",
    d: "m156.17 304.34 36.05-20.95-1.14-1.9-33 19.18-11.33-19.3-2.87 1.67 12.29 21.3z",
    id: "ele2wwir2hbx"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "254.475px 266.91px"
    },
    id: "elk37f5pa7z8",
    className: "animable",
    d: "m256.35 264.73-3.77 2.17 3.79 2.19-.02-4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "207.8px 296.015px"
    },
    id: "eliz1spuft2bh",
    className: "animable",
    d: "m252.58 266.9-93.35 53.87.01 4.36 97.13-56.04-3.79-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8 105.47a4.31 4.31 0 0 0 .37.37c-.13-.13-.26-.25-.38-.38Z",
    style: {
      fill: "none",
      transformOrigin: "120.98px 105.65px"
    },
    id: "el96aqgogaye8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.37 104.94.17.22-.18-.23Z",
    style: {
      fill: "none",
      transformOrigin: "120.45px 105.045px"
    },
    id: "elitpnvtcd5rh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.88 104.19c.05.09.11.18.17.27l-.17-.28Z",
    style: {
      fill: "none",
      transformOrigin: "119.965px 104.32px"
    },
    id: "elsc42qlmwj0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.76 106.35.22.17-.23-.18Z",
    style: {
      fill: "none",
      transformOrigin: "121.865px 106.43px"
    },
    id: "el1mwf5i5893pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36 102.73c0 .1 0 .2.07.3 0-.1-.05-.21-.07-.32Z",
    style: {
      fill: "none",
      transformOrigin: "119.395px 102.87px"
    },
    id: "elbzfbqtw7lpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59 107c.16.11.32.22.49.32l12.09 7-12.09-7c-.17-.15-.33-.26-.49-.32Z",
    style: {
      fill: "none",
      transformOrigin: "128.88px 110.66px"
    },
    id: "ely7phcw5330f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55 103.46c0 .1.09.19.13.29a2.88 2.88 0 0 1-.13-.31Z",
    style: {
      fill: "none",
      transformOrigin: "119.615px 103.595px"
    },
    id: "elww7hnhyzgbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36 102.71c0 .11 0 .22.07.32 0 .12.07.25.11.37a2.88 2.88 0 0 0 .13.31l.19.4.17.28q.14.22.3.45l.18.23.17.21.08.09c.12.13.25.25.38.38l.18.17c.12.11.26.22.4.33l.23.18.14.12.47.31c.16.11.32.22.5.32l12.09 7 44.29-25.57-12.09-7c-5.11-3-13.41-3-18.56 0l-25.64 14.91c-2.75 1.59-4 3.71-3.84 5.79a2.6 2.6 0 0 0 .05.4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "149.368px 96.77px"
    },
    id: "elhygjtsha498",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36 102.71c0 .11 0 .22.07.32 0 .12.07.25.11.37a2.88 2.88 0 0 0 .13.31l.19.4.17.28q.14.22.3.45l.18.23.17.21.08.09c.12.13.25.25.38.38l.18.17c.12.11.26.22.4.33l.23.18.14.12.47.31c.16.11.32.22.5.32l12.09 7 44.29-25.57-12.09-7c-5.11-3-13.41-3-18.56 0l-25.64 14.91c-2.75 1.59-4 3.71-3.84 5.79a2.6 2.6 0 0 0 .05.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "149.368px 96.77px"
    },
    className: "animable",
    id: "elyy74moxaiv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09 107.27c-.17-.1-.33-.21-.49-.32l-.47-.31-.14-.12-.22-.17c-.14-.11-.28-.22-.4-.33l-.18-.17a4.31 4.31 0 0 1-.37-.37l-.08-.09-.17-.21-.17-.22q-.17-.23-.3-.45c-.06-.09-.12-.18-.17-.27l-.19-.4c0-.1-.09-.19-.13-.29 0-.12-.07-.25-.11-.37 0-.1-.05-.2-.07-.3a2.6 2.6 0 0 1 0-.39v-.38l.12 41.36v.12a2.3 2.3 0 0 0 0 .26 3 3 0 0 0 0 .42v.07c0 .09.06.17.08.26s.07.27.11.4v.08a2.4 2.4 0 0 0 .11.23c.06.14.12.28.19.41v.1c0 .07.09.13.13.19s.2.31.31.46a1.1 1.1 0 0 1 .09.14l.26.3.09.1a5.21 5.21 0 0 0 .47.47l.08.07c.12.11.27.22.4.33s.24.2.37.29l.47.32.34.22.16.1 12.09 7-.12-41.35Z",
    style: {
      fill: "#37474f",
      transformOrigin: "127.361px 128.96px"
    },
    id: "els7zd5hjbxdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09 107.27c-.17-.1-.33-.21-.49-.32l-.47-.31-.14-.12-.22-.17c-.14-.11-.28-.22-.4-.33l-.18-.17a4.31 4.31 0 0 1-.37-.37l-.08-.09-.17-.21-.17-.22q-.17-.23-.3-.45c-.06-.09-.12-.18-.17-.27l-.19-.4c0-.1-.09-.19-.13-.29 0-.12-.07-.25-.11-.37 0-.1-.05-.2-.07-.3a2.6 2.6 0 0 1 0-.39v-.38l.12 41.36v.12a2.3 2.3 0 0 0 0 .26 3 3 0 0 0 0 .42v.07c0 .09.06.17.08.26s.07.27.11.4v.08a2.4 2.4 0 0 0 .11.23c.06.14.12.28.19.41v.1c0 .07.09.13.13.19s.2.31.31.46a1.1 1.1 0 0 1 .09.14l.26.3.09.1a5.21 5.21 0 0 0 .47.47l.08.07c.12.11.27.22.4.33s.24.2.37.29l.47.32.34.22.16.1 12.09 7-.12-41.35Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "127.361px 128.96px"
    },
    className: "animable",
    id: "elbjkjxfduy26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "157.385px 122.19px"
    },
    id: "elju3881uc8c",
    className: "animable",
    d: "m179.47 88.73-44.29 25.57.12 41.35 44.29-25.56-.12-41.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05 278.92Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "89.05px 278.92px"
    },
    id: "elgl8pxtif99j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.37 275.39-.27-121.1a11.92 11.92 0 0 1 5.4-9.36L243 58.25a3.85 3.85 0 0 1 3.82-.4l-5.67-3.28c-1-.63-2.39-.58-3.93.32L86.71 141.58a11.92 11.92 0 0 0-5.4 9.35L81.58 272a3.87 3.87 0 0 0 1.42 3.41l.3.17 5.59 3.26a3.82 3.82 0 0 1-1.52-3.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "164.065px 166.494px"
    },
    id: "elzg3ei9mt9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18 54.57c-1-.63-2.39-.58-3.93.32L86.71 141.58a11.34 11.34 0 0 0-4.13 4.61l5.79 3.35a11.34 11.34 0 0 1 4.13-4.61L243 58.25a3.85 3.85 0 0 1 3.82-.4Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "164.7px 101.844px"
    },
    className: "animable",
    id: "elwkoktvgi20a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.31 150.93 81.58 272a3.87 3.87 0 0 0 1.42 3.41l.3.17 5.59 3.26a3.82 3.82 0 0 1-1.55-3.46l-.27-121.1a10.47 10.47 0 0 1 1.27-4.75l-5.79-3.35a10.59 10.59 0 0 0-1.24 4.75Z",
    style: {
      opacity: 0.2,
      transformOrigin: "85.1px 212.51px"
    },
    className: "animable",
    id: "elrc8q9jynsnm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92 57.89Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "246.92px 57.89px"
    },
    id: "el4ztmggfu0cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47 61.34a3.78 3.78 0 0 0-1.56-3.45 3.85 3.85 0 0 0-3.82.4L92.5 144.93a11.92 11.92 0 0 0-5.4 9.36l.27 121.1a3.82 3.82 0 0 0 1.55 3.46h.09a3.9 3.9 0 0 0 3.76-.43l150.57-86.62a11.9 11.9 0 0 0 5.4-9.35Zm-7.81 125.83-147.95 85.2-.26-118.09a6.67 6.67 0 0 1 2.72-4.71l148-85.2.26 118.09a6.69 6.69 0 0 1-2.77 4.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "167.92px 168.353px"
    },
    id: "elid1z5rxr05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.13 64.37-3.83 2.2.25 114a6.71 6.71 0 0 1-2.72 4.71l-144.13 83v4.08l148-85.2a6.69 6.69 0 0 0 2.73-4.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "168.065px 168.365px"
    },
    id: "elb0v0agkcb3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.13 64.37-3.83 2.2.25 114a6.71 6.71 0 0 1-2.72 4.71l-144.13 83v4.08l148-85.2a6.69 6.69 0 0 0 2.73-4.71Z",
    style: {
      opacity: 0.3,
      transformOrigin: "168.065px 168.365px"
    },
    className: "animable",
    id: "el0xeqe5tz29v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.55 180.59-.25-114-144.13 83a6.67 6.67 0 0 0-2.72 4.71l.25 114 144.13-83a6.71 6.71 0 0 0 2.72-4.71Z",
    style: {
      fill: "#455a64",
      transformOrigin: "166px 167.445px"
    },
    id: "elnflkaraadb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "173.31px 182.065px"
    },
    className: "animable",
    id: "elzy5jz5whv2e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "173.395px 202.255px"
    },
    id: "el43mng3dg11c",
    className: "animable",
    d: "m195.34 187.44.01 4.29-43.9 25.34-.01-4.29 43.9-25.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "149.53px 188.175px"
    },
    id: "elwj8p8pd1g2e",
    className: "animable",
    d: "m155.66 174.52 2.65 1.51-6.14 10.63 6.17 3.52-2.62 4.54-6.18-3.51-6.13 10.62-2.65-1.5 6.14-10.63-6.18-3.52 2.63-4.55 6.18 3.51 6.13-10.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "197.09px 160.715px"
    },
    id: "eljf5b9265ejr",
    className: "animable",
    d: "m203.22 147.06 2.64 1.51-6.13 10.63 6.17 3.52-2.63 4.55-6.17-3.52-6.13 10.62-2.65-1.5 6.13-10.62-6.17-3.52 2.63-4.56 6.17 3.52 6.14-10.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "114.245px 168.12px"
    },
    id: "elozkfanax5g",
    className: "animable",
    d: "m119.22 156.76.01 2.09-8.22 4.75.01 5.14 7.33-4.23.01 2.04-7.33 4.23.01 5.43 8.52-4.92.01 2.07-10.6 6.12-.05-16.77 10.3-5.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.51 160.82 3.48 3.64-2.27 1.31-3.18-3.32c-.28.18-.59.4-.91.58l-3.63 2.08v5.1l-2.08 1.2v-16.77l5.7-3.29c3.79-2.19 6.1-1.32 6.11 2.33a10.05 10.05 0 0 1-3.22 7.14Zm-2.94.19c2.66-1.54 4.06-3.73 4.06-6.13s-1.42-2.94-4.09-1.41l-3.54 2.05v7.54l3.56-2.05",
    style: {
      fill: "#fff",
      transformOrigin: "128.955px 160.786px"
    },
    id: "ell7h7bz96lh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.69 152.06 3.47 3.64-2.27 1.3-3.16-3.33c-.3.19-.61.41-.92.59l-3.6 2.08v5.09l-2.1 1.21-.05-16.77 5.7-3.29c3.81-2.2 6.1-1.32 6.11 2.33a10 10 0 0 1-3.18 7.15Zm-2.95.19c2.68-1.54 4.07-3.73 4.06-6.13s-1.41-3-4.08-1.41l-3.54 2v7.53l3.54-2",
    style: {
      fill: "#fff",
      transformOrigin: "144.11px 152.013px"
    },
    id: "el6cvqdc8vr8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85 133.11c4.45-2.57 7.75-.82 7.76 4.11a16.08 16.08 0 0 1-7.71 13.05c-4.49 2.6-7.79.82-7.8-4.09s3.26-10.48 7.75-13.07Zm.05 15a12 12 0 0 0 5.63-9.7c0-3.73-2.44-5-5.67-3.18a12 12 0 0 0-5.68 9.73c0 3.72 2.44 5 5.72 3.15",
    style: {
      fill: "#fff",
      transformOrigin: "159.855px 141.697px"
    },
    id: "elhpr5z8f0sfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.4 133.18 3.49 3.62-2.29 1.32-3.16-3.33c-.28.18-.61.41-.91.58l-3.61 2.09v5.09l-2.08 1.2v-16.76l5.7-3.3c3.79-2.18 6.1-1.32 6.11 2.34a10.1 10.1 0 0 1-3.25 7.15Zm-2.94.18c2.67-1.54 4.06-3.73 4-6.12s-1.4-3-4.07-1.42l-3.55 2.05v7.54l3.55-2",
    style: {
      fill: "#fff",
      transformOrigin: "176.865px 133.128px"
    },
    id: "el2ztrv95u5d1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "196.68px 119.31px"
    },
    id: "elqb0p93o8fwj",
    className: "animable",
    d: "m199.91 110.18-7.13 14.73 5.63-3.25-.02-3.65 1.96-1.13.01 3.65 2.77-1.6.01 2.05-2.77 1.6.01 4.12-2.02 1.17-.01-4.12-8.13 4.69v-1.67l7.43-15.29 2.26-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94 104.77c3-1.76 5-1.09 5 1.79 0 1.62-.4 3.33-2.38 6.65l-4.45 7.53 7.49-4.32v2.07l-10.49 6.05v-1.62l5.93-10c1.53-2.62 1.82-3.83 1.82-4.89 0-1.73-1.07-2.16-3.11-1a9.46 9.46 0 0 0-3.74 4l-1.42-.6a13.8 13.8 0 0 1 5.35-5.66Z",
    style: {
      fill: "#fff",
      transformOrigin: "209.095px 114.172px"
    },
    id: "elu3vkeik67dc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 97.79c3.92-2.26 6.13-.52 6.15 4.83a14.44 14.44 0 0 1-6.88 12.78 6.5 6.5 0 0 1-3.64 1.13l.8-2.33a4.66 4.66 0 0 0 2.82-.86c3-1.71 4.83-4.91 4.82-9.11v-.61a10 10 0 0 1-4.2 4.65c-2.9 1.67-5 .88-5-2.21s2.25-6.59 5.13-8.27Zm.21 8.33a6.6 6.6 0 0 0 3.36-5.2c0-1.73-1.21-2.55-3.48-1.24a6.23 6.23 0 0 0-3.21 5.11c0 2 1.28 2.51 3.33 1.33",
    style: {
      fill: "#fff",
      transformOrigin: "221.514px 106.677px"
    },
    id: "elfwrvnut97et",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.66 79-4.28-8.19v-.12l1.4-9.25a3.91 3.91 0 0 0-1.93-4L121.56 46.4a1.86 1.86 0 0 0-1.86 3.23L139 60.71l.09.2-1.39 9.26a3.92 3.92 0 0 0 .4 2.4l4.28 8.19v.16l-6.14 14.7a3.91 3.91 0 0 0-.3 1.51v2.81a.88.88 0 0 0 .53.84 2.94 2.94 0 0 0 2.65 0 .93.93 0 0 0 .55-.77v-3l6.13-14.7a3.92 3.92 0 0 0-.14-3.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "132.434px 73.624px"
    },
    id: "elusjmhn8q1zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 69.59v-.13l2.38-6.91a3.9 3.9 0 0 0 .13-2.06l-3.44-17a1.87 1.87 0 0 0-3.67.74l3.45 17.12-2.38 6.92a4 4 0 0 0 0 2.63l2.41 6.54v.12l-3.74 12.12a4.17 4.17 0 0 0-.17 1.16v2.64a.93.93 0 0 0 .54.76 2.88 2.88 0 0 0 2.65 0 .88.88 0 0 0 .54-.84v-2.64l3.74-12.12a3.92 3.92 0 0 0-.07-2.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "149.791px 68.2755px"
    },
    id: "elqywy8aa5vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56 53.08h-6.47a3.9 3.9 0 0 0-3.26 1.74l-3.62 5.41-.12.08-4.74 1.12a3.93 3.93 0 0 0-2.7 2.26 4 4 0 0 0-.15 2.72l.53 2a.2.2 0 0 1 0 .15.27.27 0 0 1-.12.09l-1.46.36a3.92 3.92 0 0 0-2.81 2.68l-4.51 15.07a3.86 3.86 0 0 0-.13 1.14v2.32a.91.91 0 0 0 .54.77 2.94 2.94 0 0 0 2.65 0 .86.86 0 0 0 .53-.88v-2.27l4.51-15.07.13-.13 1.46-.36a3.94 3.94 0 0 0 2.64-2.28 4.16 4.16 0 0 0 .14-2.7l-.54-2a.19.19 0 0 1 0-.15.14.14 0 0 1 .12-.09L172 64a4 4 0 0 0 2.37-1.64l3.61-5.41.16-.09h6.47a1.87 1.87 0 1 0 0-3.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "170.807px 72.1927px"
    },
    id: "elrak35vwdox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "152.693px 71.5418px"
    },
    className: "animable",
    id: "elwzscqoed01k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.66 79-4.28-8.19v-.12l1.4-9.25a3.91 3.91 0 0 0-1.93-4L121.56 46.4a1.86 1.86 0 0 0-1.86 3.23L139 60.71l.09.2-1.39 9.26a3.92 3.92 0 0 0 .4 2.4l4.28 8.19v.16l-6.14 14.7a3.91 3.91 0 0 0-.3 1.51v2.81a.88.88 0 0 0 .53.84 2.94 2.94 0 0 0 2.65 0 .93.93 0 0 0 .55-.77v-3l6.13-14.7a3.92 3.92 0 0 0-.14-3.31Z",
    style: {
      fill: "#fff",
      transformOrigin: "132.434px 73.624px"
    },
    id: "els10wwpcr5dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 69.59v-.13l2.38-6.91a3.9 3.9 0 0 0 .13-2.06l-3.44-17a1.87 1.87 0 0 0-3.67.74l3.45 17.12-2.38 6.92a4 4 0 0 0 0 2.63l2.41 6.54v.12l-3.74 12.12a4.17 4.17 0 0 0-.17 1.16v2.64a.93.93 0 0 0 .54.76 2.88 2.88 0 0 0 2.65 0 .88.88 0 0 0 .54-.84v-2.64l3.74-12.12a3.92 3.92 0 0 0-.07-2.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "149.791px 68.2755px"
    },
    id: "elt4i709i36r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56 53.08h-6.47a3.9 3.9 0 0 0-3.26 1.74l-3.62 5.41-.12.08-4.74 1.12a3.93 3.93 0 0 0-2.7 2.26 4 4 0 0 0-.15 2.72l.53 2a.2.2 0 0 1 0 .15.27.27 0 0 1-.12.09l-1.46.36a3.92 3.92 0 0 0-2.81 2.68l-4.51 15.07a3.86 3.86 0 0 0-.13 1.14v2.32a.91.91 0 0 0 .54.77 2.94 2.94 0 0 0 2.65 0 .86.86 0 0 0 .53-.88v-2.27l4.51-15.07.13-.13 1.46-.36a3.94 3.94 0 0 0 2.64-2.28 4.16 4.16 0 0 0 .14-2.7l-.54-2a.19.19 0 0 1 0-.15.14.14 0 0 1 .12-.09L172 64a4 4 0 0 0 2.37-1.64l3.61-5.41.16-.09h6.47a1.87 1.87 0 1 0 0-3.73Z",
    style: {
      fill: "#fff",
      transformOrigin: "170.807px 72.1927px"
    },
    id: "ellcosxt8bqhn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "100.955px 44.435px"
    },
    id: "elyj3otadro6g",
    className: "animable",
    d: "M87.39 29.94 98.2 42.36l7.51-4.42 8.81 20.99-10.22-14.88-7.99 5.36-8.92-19.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "138.475px 36.325px"
    },
    id: "el9jryj8lq537",
    className: "animable",
    d: "m138.73 25.83-5.02 10.05 5.02.77-4.12 10.17 8.63-11.72-6.83-1.16 2.32-8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "178.605px 40.465px"
    },
    id: "elp7jszulob4",
    className: "animable",
    d: "m182.77 29.21-2.06 11.95-4.12-1.55-2.15 12.11 3.35-9.28 4.64 1.98.34-15.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.51px 46.935px"
    },
    id: "elm1j3t6tjb0i",
    className: "animable",
    d: "m189.38 50.43 8.29-7.26v3.63l5.97-4.18-8.03 8.63.21-5.1-6.44 4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "194.645px 65.28px"
    },
    id: "el8x6bon5uuvd",
    className: "animable",
    d: "m186.43 61.34 7.25 6.92 1.37-3.89 7.81 6.06-8.21-10.3-1.49 5.15-6.73-3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "121.055px 82.1px"
    },
    id: "el2dgzh5mj6qd",
    className: "animable",
    d: "m128.88 76.1-11.02 4.12 3.89 2.97-8.52 4.91 13.91-3.76-4.17-3.35 5.91-4.89z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "145.515px 56.965px"
    },
    className: "animable",
    id: "eljrzw2nildg8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "100.955px 44.435px"
    },
    id: "el9ijg2q21b6j",
    className: "animable",
    d: "M87.39 29.94 98.2 42.36l7.51-4.42 8.81 20.99-10.22-14.88-7.99 5.36-8.92-19.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "138.475px 36.325px"
    },
    id: "el8g4qjpupcxw",
    className: "animable",
    d: "m138.73 25.83-5.02 10.05 5.02.77-4.12 10.17 8.63-11.72-6.83-1.16 2.32-8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "178.605px 40.465px"
    },
    id: "elzgscf36d66d",
    className: "animable",
    d: "m182.77 29.21-2.06 11.95-4.12-1.55-2.15 12.11 3.35-9.28 4.64 1.98.34-15.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "196.51px 46.935px"
    },
    id: "el9m0w3io4bq",
    className: "animable",
    d: "m189.38 50.43 8.29-7.26v3.63l5.97-4.18-8.03 8.63.21-5.1-6.44 4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "194.645px 65.28px"
    },
    id: "elzyi99v3odbn",
    className: "animable",
    d: "m186.43 61.34 7.25 6.92 1.37-3.89 7.81 6.06-8.21-10.3-1.49 5.15-6.73-3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "121.055px 82.1px"
    },
    id: "els0lgla4eug",
    className: "animable",
    d: "m128.88 76.1-11.02 4.12 3.89 2.97-8.52 4.91 13.91-3.76-4.17-3.35 5.91-4.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelopes--inject-1105",
    className: "animable",
    style: {
      transformOrigin: "254.47px 352.795px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "258.13px 367.01px"
    },
    id: "el9s1nhr53xoi",
    className: "animable",
    d: "m284.39 352.54-60.93 8.15 8.4 20.79 60.94-8.16-8.41-20.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "253.925px 361.55px"
    },
    className: "animable",
    d: "m284.39 352.54-23.64 18.02-37.29-9.87 60.93-8.15z",
    id: "elugx5gy5zf3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "258.13px 367.01px"
    },
    className: "animable",
    d: "m284.39 352.54 8.41 20.78-60.94 8.16-8.4-20.79 37.29 9.87 23.64-18.02z",
    id: "elsfa7fi02hwe"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "335.05px 296.95px"
    },
    id: "elhu5pqv8cpsv",
    className: "animable",
    d: "m312.88 280.25-13.74 19.77 58.07 13.63 13.75-19.77-58.08-13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "341.92px 290.49px"
    },
    className: "animable",
    d: "m370.96 293.88-37.29 6.85-20.79-20.48 58.08 13.63z",
    id: "el2cco105q9pp"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "335.05px 296.95px"
    },
    className: "animable",
    d: "m370.96 293.88-13.75 19.77-58.07-13.63 13.74-19.77 20.79 20.48 37.29-6.85z",
    id: "el4ie8u87k7x3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "203.28px 331.6px"
    },
    id: "el7gprsl43m24",
    className: "animable",
    d: "m181.12 314.9-13.75 19.77 58.07 13.63 13.75-19.77-58.07-13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "210.155px 325.14px"
    },
    className: "animable",
    d: "m239.19 328.53-37.29 6.85-20.78-20.48 58.07 13.63z",
    id: "elz2shfxij90l"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "203.28px 331.6px"
    },
    className: "animable",
    d: "m239.19 328.53-13.75 19.77-58.07-13.63 13.75-19.77 20.78 20.48 37.29-6.85z",
    id: "elsv0cr1lm34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "382.425px 325.025px"
    },
    id: "elzpdt1eq3ntb",
    className: "animable",
    d: "m397.04 305.8-50.77 21.11 21.55 17.34 50.76-21.11-21.54-17.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "371.655px 316.76px"
    },
    className: "animable",
    d: "m397.04 305.8-9.83 21.92-40.94-.81 50.77-21.11z",
    id: "el4i6u39jrime"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "382.425px 325.025px"
    },
    className: "animable",
    d: "m397.04 305.8 21.54 17.34-50.76 21.11-21.55-17.34 40.94.81 9.83-21.92z",
    id: "elpinopkbzic"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "315.46px 333.9px"
    },
    id: "elhfj9gzznoff",
    className: "animable",
    d: "m299.79 314.9-20.57 17.66 51.92 20.34 20.56-17.65-51.91-20.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "325.745px 326.165px"
    },
    className: "animable",
    d: "m351.7 335.25-38.94 2.18-12.97-22.53 51.91 20.35z",
    id: "eljxppk0872xe"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "315.46px 333.9px"
    },
    className: "animable",
    d: "m351.7 335.25-20.56 17.65-51.92-20.34 20.57-17.66 12.97 22.53 38.94-2.18z",
    id: "elnilnkbytgd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "321.65px 418.435px"
    },
    id: "el03a2fdga6jot",
    className: "animable",
    d: "m345.82 402.78-36.12-4.23-12.22 35.53 36.12 4.24 12.22-35.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "312.9px 416.315px"
    },
    className: "animable",
    d: "m309.7 398.55 18.62 19.98-30.84 15.55 12.22-35.53z",
    id: "eleo7jv0kjp59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "321.65px 418.435px"
    },
    className: "animable",
    d: "m333.6 438.32-36.12-4.24 30.84-15.55-18.62-19.98 36.12 4.23-12.22 35.54z",
    id: "el89n7c8afevh"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.595px 441.78px"
    },
    id: "elx6aoa5hjqgg",
    className: "animable",
    d: "m282.75 423.27-53.46 18.75 19.15 18.27 53.46-18.75-19.15-18.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "256.02px 433.98px"
    },
    className: "animable",
    d: "M282.75 423.27 270 444.69l-40.71-2.67 53.46-18.75z",
    id: "elu1lasomwhks"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "265.595px 441.78px"
    },
    className: "animable",
    d: "m282.75 423.27 19.15 18.27-53.46 18.75-19.15-18.27 40.71 2.67 12.75-21.42z",
    id: "el153figce63k"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "321.65px 265.66px"
    },
    id: "eltgoi1basre",
    className: "animable",
    d: "m330.87 245.3-44.4 25.64 25.96 15.08 44.4-25.63-25.96-15.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "308.67px 258.12px"
    },
    className: "animable",
    d: "m286.47 270.94 38.98-2.11 5.42-23.53-44.4 25.64z",
    id: "el8e3cyduc8ya"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "321.65px 265.66px"
    },
    className: "animable",
    d: "m286.47 270.94 25.96 15.08 44.4-25.63-25.96-15.09-5.42 23.53-38.98 2.11z",
    id: "el8mqa65tjyyw"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "261.27px 333.9px"
    },
    id: "ell0ty74s42cf",
    className: "animable",
    d: "m272.26 314.44-46.5 21.59 24.52 17.33 46.5-21.59-24.52-17.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "249.01px 325.915px"
    },
    className: "animable",
    d: "m225.76 336.03 39.02 1.36 7.48-22.95-46.5 21.59z",
    id: "el9oawwqwukw"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "261.27px 333.9px"
    },
    className: "animable",
    d: "m225.76 336.03 24.52 17.33 46.5-21.59-24.52-17.33-7.48 22.95-39.02-1.36z",
    id: "elz55wra96vw9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "324.58px 315.23px"
    },
    id: "el5p0y0c4y41a",
    className: "animable",
    d: "m354.93 303.74-62.52 1.67 1.82 21.31 62.52-1.67-1.82-21.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "323.67px 311.37px"
    },
    className: "animable",
    d: "M354.93 303.74 326.06 319l-33.65-13.59 62.52-1.67z",
    id: "elqyt5qvr615"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "324.58px 315.23px"
    },
    className: "animable",
    d: "m354.93 303.74 1.82 21.31-62.52 1.67-1.82-21.31L326.06 319l28.87-15.26z",
    id: "ely2vjft9qtef"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "229.515px 310.32px"
    },
    id: "elxl4ljkx4il",
    className: "animable",
    d: "m259.87 298.83-62.52 1.67 1.82 21.31 62.51-1.67-1.81-21.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "228.61px 306.46px"
    },
    className: "animable",
    d: "M259.87 298.83 231 314.09l-33.65-13.59 62.52-1.67z",
    id: "elmufaplk6qk"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "229.515px 310.32px"
    },
    className: "animable",
    d: "m259.87 298.83 1.81 21.31-62.51 1.67-1.82-21.31L231 314.09l28.87-15.26z",
    id: "ele4js6ydtrbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94 396.62 255 386l-31.13 31.39 32 10.68ZM257 392.76l4.65 15.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "255.405px 407.035px"
    },
    id: "elpzfj8umjmnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "242.77px 401.645px"
    },
    className: "animable",
    d: "m254.99 385.95 6.69 22.36-37.82 9.03 31.13-31.39z",
    id: "eldfnthfvpneu"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "255.4px 406.98px"
    },
    className: "animable",
    d: "m255.81 428.01-31.95-10.67 37.82-9.03-6.69-22.36 31.95 10.67-31.13 31.39z",
    id: "el6b9k5qvrlbo"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "278.235px 296.96px"
    },
    id: "el0r7d2345rgg",
    className: "animable",
    d: "m269.29 276.56-17.47 34.78 35.38 6.02 17.45-34.79-35.36-6.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "268.345px 293.95px"
    },
    className: "animable",
    d: "m269.29 276.56 15.58 20.83-33.05 13.95 17.47-34.78z",
    id: "els8p6iixkg4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "278.235px 296.96px"
    },
    className: "animable",
    d: "m287.2 317.36-35.38-6.02 33.05-13.95-15.58-20.83 35.36 6.01-17.45 34.79z",
    id: "elei5ms8fotin"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "320.22px 363.275px"
    },
    id: "el3kvd482abq9",
    className: "animable",
    d: "m319.58 342.24-31.41 11.09 32.7 30.98 31.4-11.09-32.69-30.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "333.75px 357.73px"
    },
    className: "animable",
    d: "m319.58 342.24 32.69 30.98-37.04-7.39 4.35-23.59z",
    id: "eliohne6fiia"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "320.22px 363.275px"
    },
    className: "animable",
    d: "m319.58 342.24-4.35 23.59 37.04 7.39-31.4 11.09-32.7-30.98 31.41-11.09z",
    id: "eljc12vg8c1l"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "289.83px 387.365px"
    },
    id: "ellnjw4c8hsq",
    className: "animable",
    d: "m299.05 367-44.4 25.64 25.96 15.09 44.4-25.64L299.05 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "276.85px 379.82px"
    },
    className: "animable",
    d: "m254.65 392.64 38.98-2.11 5.42-23.53-44.4 25.64z",
    id: "elo9pzho9vb79"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "289.83px 387.365px"
    },
    className: "animable",
    d: "m254.65 392.64 25.96 15.09 44.4-25.64L299.05 367l-5.42 23.53-38.98 2.11z",
    id: "elc044pjkfcl"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "197.105px 403.58px"
    },
    id: "elajr4u43z2j8",
    className: "animable",
    d: "m197.61 382.55-32 10.5 30.98 31.56 32.01-10.5-30.99-31.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "183.925px 408.83px"
    },
    className: "animable",
    d: "m202.24 401.12-5.65 23.49-30.98-31.56 36.63 8.07z",
    id: "el04q6xn0ilufi"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "197.105px 403.58px"
    },
    className: "animable",
    d: "m197.61 382.55 30.99 31.56-32.01 10.5-30.98-31.56 30.98 31.56 5.65-23.49-36.63-8.07 32-10.5z",
    id: "elin3cbfgbcpg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "216.765px 386.37px"
    },
    id: "elubzeg5dfkq",
    className: "animable",
    d: "m229.25 366.64-36.23 3.78 11.26 35.68 36.23-3.77-11.26-35.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "225.515px 384.485px"
    },
    className: "animable",
    d: "m229.25 366.64 11.26 35.69-29.99-14.63 18.73-21.06z",
    id: "elq2mjll76ho"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "216.765px 386.37px"
    },
    className: "animable",
    d: "m229.25 366.64-18.73 21.06 29.99 14.63-36.23 3.77-11.26-35.68 36.23-3.78z",
    id: "elz9t312r9sz"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "159.37px 413.315px"
    },
    id: "elb8jochhlafi",
    className: "animable",
    d: "m190.91 402.95-31.96-10.67 6.69 22.36-6.69-22.36-31.12 31.39 31.95 10.68 31.13-31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "146.735px 407.975px"
    },
    className: "animable",
    d: "m158.95 392.28 6.69 22.36-37.81 9.03 31.12-31.39z",
    id: "eli71nc8k9bq"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "159.37px 413.315px"
    },
    className: "animable",
    d: "m159.78 434.35-31.95-10.68 37.81-9.03-6.69-22.36 31.96 10.67-31.13 31.4z",
    id: "elbaavml8l01q"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "132.19px 361.64px"
    },
    id: "el6b29aw0lv4x",
    className: "animable",
    d: "m122.97 341.28-25.96 15.08L141.42 382l25.95-15.09-44.4-25.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "145.17px 354.095px"
    },
    className: "animable",
    d: "m167.37 366.91-38.98-2.11-5.42-23.52 44.4 25.63z",
    id: "elgv8mttwf0cv"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "132.19px 361.64px"
    },
    className: "animable",
    d: "M167.37 366.91 141.42 382l-44.41-25.64 25.96-15.08 5.42 23.52 38.98 2.11z",
    id: "el4xjumj4c0ze"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "115.965px 380.545px"
    },
    id: "eloty4orbm3i",
    className: "animable",
    d: "m126.04 360.36-35.68 5.22 15.53 35.15 35.68-5.22-15.53-35.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "125.73px 377.935px"
    },
    className: "animable",
    d: "m126.04 360.36 15.53 35.15-31.68-13.38 16.15-21.77z",
    id: "elr64mtms611j"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "115.965px 380.545px"
    },
    className: "animable",
    d: "m126.04 360.36-16.15 21.77 31.68 13.38-35.68 5.22-15.53-35.15 35.68-5.22z",
    id: "el8asvtqpyrcs"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "197.105px 356.31px"
    },
    id: "elxccs7lrflg",
    className: "animable",
    d: "m226.53 344.04-62.31 3.29 3.46 21.25 62.31-3.29-3.46-21.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "195.375px 352.04px"
    },
    className: "animable",
    d: "m226.53 344.04-27.66 16-34.65-12.71 62.31-3.29z",
    id: "elzmjw6dvtac9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "197.105px 356.31px"
    },
    className: "animable",
    d: "m226.53 344.04 3.46 21.25-62.31 3.29-3.46-21.25 34.65 12.71 27.66-16z",
    id: "ell8q64mvvlb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "229.9px 300.125px"
    },
    className: "animable",
    d: "m223.57 283.62-9.19 5.31-17.35 10.01 45.18 17.69 20.56-17.66-39.2-15.35z",
    id: "el0qqm67fz4hq"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "231.45px 297.75px"
    },
    id: "el55svj9ka3ag",
    className: "animable",
    d: "m226.68 281.85-9.2 5.3-17.35 10.01 42.08 16.49 20.56-17.66-36.09-14.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "240.125px 290.01px"
    },
    className: "animable",
    d: "m223.83 298.17 38.94-2.18-36.09-14.14-9.2 5.3 6.35 11.02z",
    id: "el3r3bpq9i7z8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "231.45px 300.4px"
    },
    className: "animable",
    d: "m262.77 295.99-38.94 2.18-6.35-11.02-17.35 10.01 42.08 16.49 20.56-17.66z",
    id: "elgu2mddc14zj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1105",
    className: "animable",
    style: {
      transformOrigin: "379.722px 284.891px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m416.25 220.28 1.33-22.53a18.61 18.61 0 0 0-7.39-16l-8.09-6.09 1.18 48.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "409.857px 199.83px"
    },
    id: "elb7adbotsrn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.25 220.28 1.33-22.53a18.61 18.61 0 0 0-7.39-16l-8.09-6.09 1.18 48.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "409.857px 199.83px"
    },
    className: "animable",
    id: "eloswfoo8m4sg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67 195.63a54.67 54.67 0 0 0 12 2.64 8.7 8.7 0 0 1-6.71 1.66 8.49 8.49 0 0 1-5.29-4.3Z",
    style: {
      opacity: 0.1,
      transformOrigin: "409.67px 197.84px"
    },
    className: "animable",
    id: "elymjjij7us6j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7 394.43c-.66 2.07-2.94 3.26-5.11 3.43a25.75 25.75 0 0 1-6.45-.82c-4.8-.87-9.43 0-14.21-.12a20.32 20.32 0 0 1-4.67-.51 7.69 7.69 0 0 1-4-2.36 5.31 5.31 0 0 1-1.15-2.5 5 5 0 0 0 1.15 3.91 7.74 7.74 0 0 0 4 2.35 20.32 20.32 0 0 0 4.67.51c4.78.11 9.41-.75 14.21.12a25.31 25.31 0 0 0 6.45.83c2.17-.18 4.45-1.36 5.11-3.44a5.48 5.48 0 0 0 .17-2.21 5.84 5.84 0 0 1-.17.81Z",
    style: {
      fill: "#263238",
      transformOrigin: "370.99px 395.41px"
    },
    id: "elefiqmg3b8bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.58 390.45-.89-4.36a6.35 6.35 0 0 0-.74-2.21 2.15 2.15 0 0 0-1.94-1.11c-2.62-.35-6.32-1.3-8.5.2a19.58 19.58 0 0 1-11.75 3.41c-2.17-.08-4.34-.53-6.5-.26s-4.39 1.46-5 3.54a4.31 4.31 0 0 0-.11 1.89 5.31 5.31 0 0 0 1.15 2.5 7.69 7.69 0 0 0 4 2.36 20.32 20.32 0 0 0 4.67.51c4.78.11 9.41-.75 14.21.12a25.75 25.75 0 0 0 6.45.82c2.17-.17 4.45-1.36 5.11-3.43a5.84 5.84 0 0 0 .17-.81 10.34 10.34 0 0 0-.33-3.17Z",
    style: {
      fill: "#37474f",
      transformOrigin: "371.008px 390.005px"
    },
    id: "elsgrseq8u7ij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.87 378.4-.18 5.68a2.24 2.24 0 0 0 2.08 2.32 36.33 36.33 0 0 0 5.72 0 3.24 3.24 0 0 0 2.93-3l.23-4.2Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "381.169px 382.456px"
    },
    id: "eleya2z2vns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 375.38a4.46 4.46 0 0 1-.76 2.35 4.32 4.32 0 0 1-2.68 1.51 6.78 6.78 0 0 1-6.65-2.74c-.72-1-1.13-2.25-1.8-3.31a15.14 15.14 0 0 0-3.73-3.63 15.7 15.7 0 0 1-3.76-3.6 5.31 5.31 0 0 1-.71-4.8 3.37 3.37 0 0 0-.36.61 5.47 5.47 0 0 0 .68 5.11 16.08 16.08 0 0 0 3.83 3.71 15.39 15.39 0 0 1 3.81 3.74c.69 1.09 1.1 2.34 1.83 3.41a6.86 6.86 0 0 0 6.78 2.82 4.37 4.37 0 0 0 2.74-1.55 5.27 5.27 0 0 0 .79-3.27c-.01-.12-.01-.24-.01-.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "402.616px 370.91px"
    },
    id: "elc6jcey2vpm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.22 368.26c-1.72-3-5.28-5.23-8-7.37a10.25 10.25 0 0 0-5.32-2.42 5 5 0 0 0-5 2.53c0 .05 0 .11-.05.16a5.31 5.31 0 0 0 .71 4.8 15.7 15.7 0 0 0 3.76 3.6 15.14 15.14 0 0 1 3.73 3.63c.67 1.06 1.08 2.28 1.8 3.31a6.78 6.78 0 0 0 6.65 2.74 4.32 4.32 0 0 0 2.68-1.51 4.46 4.46 0 0 0 .76-2.35v-.82a13.16 13.16 0 0 0-1.72-6.3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "402.754px 368.883px"
    },
    id: "el5xlx20nvq2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 365.63v5.16a8.65 8.65 0 0 0 8-.35l.48-4.65Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "407.98px 368.617px"
    },
    id: "eldj877t8vng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.61 272c1.54 4.65-.36 26.7-1.26 47.86 3.35 8 3.45 30.91 1.51 47 0 0-6.56 2-12.62-.09l-5.4-44.62-1.06-25.15s-1.91 22.31-4.1 36.63c2.06 11 2.28 13.27-2.81 47 0 0-8.26 2.49-14.45-.55-2.88-47.38.47-90.26 1-105.79Z",
    style: {
      fill: "#455a64",
      transformOrigin: "393.7px 326.795px"
    },
    id: "el0nbo5kwxt9qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.42 312.36-.86-20.52c5.3 0 10.23-4 14-7.72-3.6 6.4-10.56 9.24-10.56 9.24Z",
    style: {
      opacity: 0.3,
      transformOrigin: "401.56px 298.24px"
    },
    className: "animable",
    id: "elqwgxt98llm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.79 230.73-.16 44.86c23.65 9.91 39 1 41.07-3.7-1.09-16.35 2.77-35.48 2.47-43.61s-1.29-17.29-13.89-15.45l-13.4 1.31-6.8 1.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "395.408px 246.336px"
    },
    id: "el76e0lo5vxwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.28 206.41a3.62 3.62 0 0 0 2.62-.89 2.6 2.6 0 0 0 .62-2.25 2.45 2.45 0 0 0 1.8-1.46 2.81 2.81 0 0 0-.42-2.45 4.11 4.11 0 0 0 2.66-2.17 4.31 4.31 0 0 0 .12-3.53 3.82 3.82 0 0 0 2.68-2.6 4.14 4.14 0 0 0-.76-3.82 5.17 5.17 0 0 0 .6-5.14 5.42 5.42 0 0 0-4.41-3 5.29 5.29 0 0 0-1.73-4.75 5.1 5.1 0 0 0-4.87-.95 4.68 4.68 0 0 0-7.8-1.34 3.59 3.59 0 0 0-3.16-1.17 3.7 3.7 0 0 0-2.85 1.89 4.79 4.79 0 0 0-6.77 4.58 2.82 2.82 0 0 0-2 2.79 3 3 0 0 0 2.33 2.69 66.93 66.93 0 0 0 6.28 18.41c1.33 2.59 3 5.21 5.54 6.55 2.76 1.48 7.13.65 9.52-1.39Z",
    style: {
      fill: "#455a64",
      transformOrigin: "396.616px 189.532px"
    },
    id: "elx77tcvzj68q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "379.71px 194.245px"
    },
    id: "el9svu53xy5rh",
    className: "animable",
    d: "m380.96 191.27-2.77 4.83 3.04 1.12-.27-5.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92 182.87a45 45 0 0 0-.8 20.5 7 7 0 0 0 1.28 3.25 5.13 5.13 0 0 0 3.52 1.62 15.12 15.12 0 0 0 4-.38v6.28c4.76 1.12 9.66 1.56 13.4-1.31v-6.42a17 17 0 0 1-8.32.51c-3.29-1.77-3.95-7.78-3.49-9.37a2.47 2.47 0 0 0 2.57.9 3.41 3.41 0 0 0 2.14-1.69 7.13 7.13 0 0 0 .8-2.67 4.88 4.88 0 0 0-.49-3.31 3.47 3.47 0 0 0-3.73-1.26 5.35 5.35 0 0 0-3.14 2.62 9.25 9.25 0 0 0-.55 1.2.74.74 0 0 1-1.44-.18 9.91 9.91 0 0 1 .94-5.25 3.66 3.66 0 0 1-2.69-1.65 3.46 3.46 0 0 1-.52-3 9.93 9.93 0 0 1-3.48-.39Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "391.811px 198.935px"
    },
    id: "elx1k3nwe6wbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72 191.84a15.46 15.46 0 0 0 11.73-4.84 1.42 1.42 0 0 0 .2-1.7 1.38 1.38 0 0 0-2-.4 9.28 9.28 0 0 1-4.42 1.88c.11-2.33 3.34-6.87 5-8.51a3 3 0 0 0 1.1-1.56 1.3 1.3 0 0 0-.41-1.12 1.24 1.24 0 0 0-1.12-.34 1 1 0 0 0 .62-1 1.23 1.23 0 0 0-.81-.95 1.6 1.6 0 0 0-1.27 0 1 1 0 0 0-.7-.79 1.73 1.73 0 0 0-1.1 0 5.58 5.58 0 0 0-1.05.49 1.52 1.52 0 0 0-1.84-.52c-4.21 2.14-9.26 9-9.3 13.72a5.87 5.87 0 0 0 5.37 5.64Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "389.097px 182.102px"
    },
    id: "elp0l0ms8h6hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.75 175.17a11.38 11.38 0 0 0-5.37 5.44c.39-3.61 3.94-5.28 5.37-5.44Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "393.065px 177.89px"
    },
    id: "el15xicu543g8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.29 173.19c-3.56 1.69-5.13 3.46-6.1 5a8.22 8.22 0 0 1 6.1-5Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "391.24px 175.69px"
    },
    id: "el322cf40mt2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44 172.93a11.65 11.65 0 0 0-5.05 4.11 6.33 6.33 0 0 1 5.05-4.11Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "388.915px 174.985px"
    },
    id: "elukm1cl38gx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79 189.48a12.85 12.85 0 0 1-7.48 1.12 7.17 7.17 0 0 0-2.36-3.72 7 7 0 0 0-2.61-1.36v.61a5.87 5.87 0 0 0 5.42 5.71 15.46 15.46 0 0 0 11.69-4.84 1.39 1.39 0 0 0 .22-1.63 12.93 12.93 0 0 1-4.88 4.11Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "389.09px 188.608px"
    },
    id: "elbzuys5t2vsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 229c-4 .07-8 .27-12.07.42l-.84 1.36v8.4A18.73 18.73 0 0 0 386.7 229Z",
    style: {
      opacity: 0.2,
      transformOrigin: "380.245px 234.09px"
    },
    className: "animable",
    id: "el1mcasa7psv1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.09 214.81-26.72-7.57L383.9 196c3.42-6.26-2.85-11.59-8.17-10.82l-27.21 13.44a11.48 11.48 0 0 0-6.69 10.44 11.49 11.49 0 0 0 6.84 10.51l31 13.74c9.33 3.13 15.85-16.11 7.42-18.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "366.409px 209.38px"
    },
    id: "eltmz1xnzystq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.37 207.24-7.63-2.17a39.36 39.36 0 0 1 12-.57l1.12.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "359.3px 205.76px"
    },
    className: "animable",
    id: "elmj8li7er3vc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1105",
    className: "animable animator-active",
    style: {
      transformOrigin: "300.256px 132.248px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m273.68 88 64.43 37.18a7.17 7.17 0 0 1 2.69 2.72 7.26 7.26 0 0 1 .93 3.53V171c0 4.84-4.11 8.12-9.52 5l-5.14-2.93-1.05-.6-.23-.13-34.44-20-23.57-13.47a7.21 7.21 0 0 1-3.63-6.25V93c0-5.16 6.3-6.85 9.53-5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "302.94px 132.248px"
    },
    id: "elwfwav4cmw3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05 128.73Z",
    style: {
      fill: "none",
      transformOrigin: "333.05px 128.73px"
    },
    id: "elimd7uhp76i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 131.15a7.37 7.37 0 0 0-1.93-2.41 6.7 6.7 0 0 0-.87-.6L267.75 91a2.4 2.4 0 0 0-3.6 2.08c0-5.2 6.3-6.89 9.53-5l64.43 37.18a7.17 7.17 0 0 1 2.69 2.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "302.475px 109.24px"
    },
    className: "animable",
    id: "el66l9f9qmzn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.8 173.93v-39.54a6.11 6.11 0 0 0-.06-.86 7.68 7.68 0 0 0-.75-2.38l5.81-3.24a7.26 7.26 0 0 1 .93 3.53V171c0 4.84-4.11 8.12-9.52 5a2.4 2.4 0 0 0 3.59-2.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "336.97px 152.566px"
    },
    className: "animable",
    id: "eli5tejelxsb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      transformOrigin: "325.905px 172.415px"
    },
    id: "el5f67zz56jdc",
    className: "animable",
    d: "m326.02 172.48-.23-.13.23.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "326.545px 172.78px"
    },
    id: "elfn7t86id9zl",
    className: "animable",
    d: "m327.07 173.08-1.05-.6 1.05.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "261.765px 113.355px"
    },
    id: "el16soep8xfh1",
    className: "animable",
    d: "m259.38 114.74 4.77-2.77v1.4l-4.77 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "261.765px 113.355px"
    },
    className: "animable",
    d: "m259.38 114.74 4.77-2.77v1.4l-4.77 1.37z",
    id: "elnqy5gqrrp3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 113.13-5.35 1.49a1.17 1.17 0 0 0-.48 2l5.56 5.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "261.891px 117.45px"
    },
    id: "el4sk2j8a9qad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "273.48px 111.03px"
    },
    id: "el64g5k8st3e4",
    className: "animable",
    d: "M276.72 109.38v1.86l-2.22-1.27-.01 6.45-2.05-1.18.02-6.46-2.22-1.28v-1.86l6.48 3.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.09 128.86 1.56 3.52-2.2-1.27-1.3-3-1.15-.61v2.21l-2-1.18v-8.32l3.31 1.91a5.92 5.92 0 0 1 3.2 4.93c0 1.23-.51 1.83-1.42 1.81Zm-1.92-2.52c.85.49 1.28.29 1.28-.48a2.25 2.25 0 0 0-1.27-2l-1.14-.65v2.43l1.14.66",
    style: {
      fill: "#fff",
      transformOrigin: "275.325px 126.295px"
    },
    id: "elfxpbhqnw82c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 111.71a8.2 8.2 0 0 1 4 6.64c0 2.5-1.72 3.34-4 2a8.25 8.25 0 0 1-4-6.64c0-2.5 1.72-3.34 4-2Zm0 6.7c1.09.63 2 .18 2-1.25a4.21 4.21 0 0 0-1.94-3.5c-1.1-.64-2-.19-2 1.24a4.18 4.18 0 0 0 1.95 3.51",
    style: {
      fill: "#fff",
      transformOrigin: "281px 116.03px"
    },
    id: "elnusjb8668k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8 116.76a8.23 8.23 0 0 1 4 6.64c0 2.5-1.72 3.34-4 2a8.23 8.23 0 0 1-4-6.65c-.04-2.49 1.68-3.33 4-1.99Zm0 6.7c1.09.64 2 .18 2-1.25a4.19 4.19 0 0 0-1.94-3.5c-1.1-.63-2-.19-2 1.24a4.19 4.19 0 0 0 1.95 3.51",
    style: {
      fill: "#fff",
      transformOrigin: "289.8px 121.08px"
    },
    id: "el2qwvxz0ljr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09 137.58v4.61c0 2.49-1.26 3.15-3.41 1.92a6.59 6.59 0 0 1-3.39-5.85v-4.61l2.05 1.19v4.53a2.92 2.92 0 0 0 1.37 2.8c.85.49 1.36.21 1.37-1.22v-4.53Z",
    style: {
      fill: "#fff",
      transformOrigin: "298.69px 139.181px"
    },
    id: "elcjuwo7345y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "302.09px 128.2px"
    },
    id: "el7c46kck7a1g",
    className: "animable",
    d: "M306.3 126.46v8.33l-1.89-1.09v-4.42l-1.87 2.52-.92-.53-1.83-4.54-.02 4.29-1.89-1.09.02-8.32 1.69.97 2.53 6.27 2.5-3.37 1.68.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "306.36px 144.22px"
    },
    id: "elssvot9696tj",
    className: "animable",
    d: "M309.15 141.66v1.82l-3.65-2.1v1.4l3.21 1.85v1.77l-3.21-1.86-.01 1.52 3.78 2.18-.01 1.82-5.81-3.36.03-8.32 5.67 3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.12 129.82 315.3 140l-2.13-1.24-.57-1.95-3.05-1.81-.58 1.29-2.09-1.2 3.22-6.48Zm-2 3.83 1.86 1.08-.92-3.2-.94 2.12",
    style: {
      fill: "#fff",
      transformOrigin: "311.09px 134.305px"
    },
    id: "elo7gwe4r8pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.25 143.87a9.5 9.5 0 0 1 2.63 2.24l-.63 1.38a8 8 0 0 0-2-1.8c-.86-.5-1.17-.35-1.17.07 0 1.27 4.1 2.69 4.09 5.76 0 1.45-1.06 2.08-3.21.83a10.53 10.53 0 0 1-3.05-2.67l.68-1.34a9 9 0 0 0 2.39 2.2c.85.48 1.18.4 1.18 0 0-1.32-4.12-2.74-4.11-5.83-.05-1.48 1.05-2.08 3.2-.84Z",
    style: {
      fill: "#fff",
      transformOrigin: "313.04px 148.11px"
    },
    id: "elfqdyx0su7f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "319.34px 138.15px"
    },
    id: "elm2y09mam4gj",
    className: "animable",
    d: "m322.8 135.98-.03 8.32-1.69-.98-3.18-6.27-.01 4.43-2.01-1.16.03-8.32 1.68.97 3.18 6.28.02-4.43 2.01 1.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "327.11px 141.825px"
    },
    id: "elenfiojrdh1p",
    className: "animable",
    d: "m330.9 140.66-2.8 3.73v2.98l-2.05-1.18.01-3.02-2.74-6.89 2.15 1.25 1.72 4.29 1.72-2.31 1.99 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "282.54px 130.465px"
    },
    id: "elif25wnzo53h",
    className: "animable",
    d: "m285.33 127.91-.01 1.81-3.64-2.1-.01 1.4 3.21 1.85v1.77l-3.21-1.86-.01 1.52 3.79 2.19-.01 1.81-5.81-3.35.02-8.32 5.68 3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.73 140.84.88 1.72a1.74 1.74 0 0 1-2-.12c-1.18-.68-1.95-1.6-3.16-3.74a8.2 8.2 0 0 1-3.2-6.11c0-2.5 1.71-3.34 4-2a8.24 8.24 0 0 1 4 6.65c0 1.89-1 2.83-2.47 2.59a2.28 2.28 0 0 0 .85 1 1 1 0 0 0 1.1.01Zm-3.5-3.56c1.09.63 2 .19 2-1.24a4.2 4.2 0 0 0-1.95-3.51c-1.09-.63-2-.19-2 1.25a4.2 4.2 0 0 0 2 3.5",
    style: {
      fill: "#fff",
      transformOrigin: "290.43px 136.388px"
    },
    id: "elwdebi6l2rgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "319.575px 151.2px"
    },
    id: "elcxsfavoil1l",
    className: "animable",
    d: "m322.82 149.55-.01 1.86-2.21-1.27-.02 6.45-2.04-1.18.01-6.45-2.22-1.29.01-1.86 6.48 3.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.39 151.45a10 10 0 0 1 2.63 2.24l-.64 1.39a8.22 8.22 0 0 0-2-1.81c-.86-.49-1.17-.34-1.17.08 0 1.27 4.1 2.69 4.1 5.76 0 1.44-1.07 2.07-3.22.83a10.56 10.56 0 0 1-3-2.68l.68-1.34a8.7 8.7 0 0 0 2.39 2.2c.84.49 1.18.4 1.18 0 0-1.32-4.12-2.73-4.11-5.83-.05-1.48 1.01-2.08 3.16-.84Z",
    style: {
      fill: "#fff",
      transformOrigin: "326.2px 155.691px"
    },
    id: "eltknmiptkxs",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooManyRequests);
export default __webpack_public_path__ + "static/media/tooManyRequests.f80cc3b2ec6bece740b61049614b16e0.svg";
export { ForwardRef as ReactComponent };